const storageMethods = {
  not_selected: 'not_selected',
  use_ccid: 'use_ccid',
  do_not_use_ccid: 'do_not_use_ccid',
};

module.exports = {
  storageMethods,
};
